import type { ReactNode } from 'react';

import focus from './focus.module.css';
import styles from './Banner.module.css';

export type BannerTone = 'info' | 'warn' | 'credit' | 'debit';

export interface BannerProps {
  readonly tone?: BannerTone;
  readonly children: ReactNode;
  /** Present makes the banner dismissible. A price-change notice is not (`SUB-06`). */
  readonly onDismiss?: () => void;
  readonly dismissLabel?: string;
}

/**
 * A persistent message attached to a screen: read-only ledger, price change ahead, offline queue waiting
 * (`LED-08`, `SUB-06`).
 *
 * Not a toast — a banner stays until the thing it describes changes. `role="status"` announces it once
 * without interrupting; a banner that shouted would be shouting on every render.
 */
export function Banner({ tone = 'info', children, onDismiss, dismissLabel = 'Dismiss' }: BannerProps): React.JSX.Element {
  return (
    <div role="status" className={[styles.banner, styles[tone]].join(' ')}>
      <div className={styles.body}>{children}</div>
      {onDismiss ? (
        <button type="button" className={[styles.dismiss, focus.focusable].join(' ')} onClick={onDismiss}>
          {dismissLabel}
        </button>
      ) : null}
    </div>
  );
}
